import React from "react";

const SendSVG = () => {
  return (
    <svg
      width="16"
      height="16"
      viewBox="0 0 16 16"
      style={{ display: "flex" }} 
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_1904_15116)">
        <path
          d="M14.6673 1.33398L7.33398 8.66732"
          stroke="white"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M14.6673 1.33398L10.0007 14.6673L7.33398 8.66732L1.33398 6.00065L14.6673 1.33398Z"
          stroke="white"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </g>
      <defs>
        <clipPath id="clip0_1904_15116">
          <rect width="16" height="16" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
};

export default SendSVG;
